import {$, w} from './constants';

const call_products_filtered = ( category, price, size) => {
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { 
            action : 'filter_product', 
            cat_id: category,
            price_id : price,
            size_id : size,
        },
        success: function(data){
            $('#grid_products').html( data );
        },
        error: function(errors){
            console.log( errors );
        }
    });
}

w.load(() => {

    $(document).on('submit', '#add-to-cart-form', function ( e ) {
        
        e.preventDefault();

        let product_id = $( '#product-id' ).val();
        let product_fields = $(this).serializeArray();
        let fields = [];

        if( product_fields.length ){
            product_fields.map( ( item, key, array ) => {
                fields[ item.name ] = item.value;
            });
        };

        let data = {
            action: 'cart',
            //action: 'woocommerce_ajax_add_to_cart',
            product_id: fields[ 'product_id' ],
            product_sku: '',
            quantity: 1,
            variation_id: 0,
        };

        //console.log( wc_add_to_cart_params.ajax_url );
        //console.log( cltvo_js_vars.ajax_url );

        console.log( data );

        $.ajax({
            type: 'post',
            url: cltvo_js_vars.ajax_url,
            data: data,
            beforeSend: function (response) {
                //$thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                //$thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {


                console.log( response );

                if (response.error && response.product_url) {
                    console.log( 'error' );
                    //window.location = response.product_url;
                } else {

                    //Si se guardó correctamente, mostramos el popup del bag
                    if( $( '#popup-bag' ).length ){
                        let price = parseInt( fields[ 'product_price' ] );

                        $( '#popup-bag' ).removeClass( 'hide' );
                        $( '#popup-bag-title' ).text( fields[ 'product_title' ] );
                        $( '#popup-bag-price' ).text( `$ ${price.format(2)} MXN` );
                        $( '#popup-bag-img' ).attr( 'src', fields[ 'product_img_src' ] );

                        //Agregamos el contador a las bolsas
                        $( '.button--bag' ).each(function(index, el) {
                             $( el ).attr( 'data-cart-count', response.qty );
                        });

                        setTimeout(function() { 
                            $( '#popup-bag' ).addClass( 'hide' );
                        }, 5000);
                    }

                    console.log( response.cart_hash );
                    console.log( response.fragments );
                    //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                }
                
                return;
            },
        });
    });

    /* P R O D U C T S : Filters */

    /*__ D E S K T O P __*/
    let choice_cat = $('#cat_product').val();
    let choice_price = null, choice_size = null;

    $('.filter_option_price').on( 'click', function(){

        $('.filter_option_price').removeClass('checked');

		choice_price = $(this).val();
        $(this).addClass('checked');

        console.log( choice_cat + '+' + choice_price + ' + ' + choice_size );
        call_products_filtered( choice_cat, choice_price, choice_size );
	});

    $('.filter_option_size').on( 'click', function(){

        $('.filter_option_size').removeClass('checked');

		choice_size = $(this).val();
        $(this).addClass('checked');

        console.log( choice_cat + '+' + choice_price + ' + ' + choice_size );

        call_products_filtered( choice_cat, choice_price, choice_size );
	});

    /*__ END/ D E S K T O P __*/

    /*__ M O B I L E __*/
    let choice_cat_mobile = $('#cat_product').val();
    let choice_price_mobile = null, choice_size_mobile = null;

    $('.filter_option_price_mobile').on( 'click', function(){

        $('.filter_option_size_mobile', this).removeClass('checked');

		choice_price = $(this).val();
        $(this).addClass('checked');

        console.log( choice_cat + '+' + choice_price + ' + ' + choice_size );
	});

    $('.filter_option_size_mobile').on( 'click', function(){

        $('.filter_option_size_mobile').removeClass('checked');

		choice_size = $(this).val();
        $(this).addClass('checked');

        console.log( choice_cat + '+' + choice_price + ' + ' + choice_size );

       // call_products_filtered( choice_cat, choice_price, choice_size );
	});

    $('#submit_options_mobile').on( 'click', function(){
        call_products_filtered( choice_cat, choice_price, choice_size );

        setTimeout( function(){
            $('.filter_target_dropdown_mobile').removeClass('active');
        }, 1500);
        
    });

    /*__ END/ M O B I L E __*/

});

Number.prototype.format = function(n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};
